import Rollbar from "rollbar";

import { Env } from "../Env";

export interface RollbarConfig {
  accessToken?: string;
  environment?: string;
  codeVersion?: string;
}

const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
};

export function makeClientConfig(config: RollbarConfig) {
  return {
    accessToken: config.accessToken,
    environment: config.environment ?? Env.NODE_ENV ?? "development",
    payload: {
      code_version: config.codeVersion ?? "1.0.0",
    },
    ...baseConfig,
  };
}

export function createClientInstance(config: RollbarConfig): Rollbar {
  return new Rollbar(makeClientConfig(config));
}

export function createServerInstance(config: RollbarConfig): Rollbar | null {
  // Only create instance on server-side (not in browser)
  // eslint-disable-next-line no-restricted-properties, turbo/no-undeclared-env-vars
  if (typeof process === "undefined" || process.env.NEXT_RUNTIME === "edge") {
    return null;
  }
  if (!config.accessToken) return null;

  return new Rollbar({
    accessToken: config.accessToken,
    environment: config.environment ?? Env.NODE_ENV ?? "development",
    payload: {
      code_version: config.codeVersion ?? "1.0.0",
    },
    ...baseConfig,
  });
}

// Re-export Rollbar class
export default Rollbar;
export type RollbarClientConfig = ReturnType<typeof makeClientConfig>;
